module.exports = __webpack_public_path__ + "static/media/zaha park shot 2.7bc8d4b3.webp";